<template>
  <div class="container">
    <h5>Basistabellen</h5>
    <button @click="addTable" class="btn btn-primary">Neue Tabelle</button>
    <ul class="list-group mt-2">
      <li class="table-item list-group-item" v-for="(t,index) in tables" :key="index">
        <DataTableItem :sources="sources" :table="t" @editjoin="editJoin" :index="index" @edit="$emit('edit',index)" @delete="$emit('delete',index)" />
      </li>
    </ul>
  </div>
</template>

<script>
import DataTableItem from '@/components/genericdata/DataTableItem.vue'

export default {
  name: 'MultiTableSource',
  props: ["sources","tables"],
  components: {
    DataTableItem,
  },
  methods: {
    addTable: function() {
      console.log('add table');
      //console.log(JSON.stringify(this.tables));
      this.tables.push({table:{name: 'Table' + this.tables.length },datasource:{}});
    },
    editJoin(idx) {
      this.$emit('editjoin',idx);
    }
  }
}
</script>

<style scoped>
.table-item:nth-child(2n+1) {
  background-color: #eee;
}
</style>
